import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
    Search1Icon,
    UserAppointmentImg1,
    UserAppointmentImg4
} from "../../Constant/Index";
const TherapistServices = () => {
    const Services = [
        {
            name: "Child Psychotherapy",
            para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            image: UserAppointmentImg1
        },
        {
            name: "Couples Psychotherapy",
            para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            image: UserAppointmentImg4
        }
    ];
    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="profile-box">
                                    <div className="top-heading d-sm-flex gap-4 align-items-center pb-4">
                                        <h3 className="md-heading min-width-fit mb-0">My Offered Service</h3>
                                        <hr className="w-100" />
                                        <Link className="secondary-btn-2 ms-auto d-block width-fit" to="/therapist/service/add">Add New Service</Link>

                                    </div>
                                    {/* <div className="form-area">
                                        <div className="form-group password">
                                            <input type="text" name="" className="form-control border-0" id="" />
                                            <button className="show-password bg-transparent" type="button">
                                                <img src={Search1Icon} className="eye-icon" alt="" />
                                            </button>
                                        </div>
                                    </div> */}
                                    <div className="appointment-list">
                                        {
                                            Services.map((Service, index) => (
                                                
                                                    <div className="single-appointment" key={index}>
                                                        <div className="about-appointment">
                                                            <figure className="appointment-img">
                                                                <img src={Service.image} alt={Service.name} className="img-fluid img-here" />
                                                            </figure>
                                                            <div className="appointment-data">
                                                                <span className="name">{Service.name}</span>
                                                                <p className="text">{Service.para}</p>
                                                            </div>
                                                        </div>
                                                        <div className="time-date">
                                                            <button className="remove-btn">
                                                                <span className="the-svg">
                                                                    <svg width="15" height="16" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M7 11H12" stroke="#E53935" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M1 3.77174C3.42817 6.23582 15.5718 6.23582 18 3.77174M1.03778 3.11946C1.02348 3.0366 1.03275 2.9515 1.06456 2.87344C1.09637 2.79539 1.14951 2.7274 1.21817 2.6769C1.8755 2.21957 4.12989 1 9.5 1C14.8701 1 17.1245 2.21957 17.7818 2.6769C17.8507 2.72729 17.904 2.79523 17.936 2.87329C17.9679 2.95135 17.9774 3.03652 17.9632 3.11946L16.3576 14.8938C16.2808 15.4574 16.0721 15.996 15.7477 16.4677C15.4234 16.9395 14.9922 17.3317 14.4876 17.6138L14.1854 17.7829C12.7584 18.5805 11.1434 19 9.5 19C7.85656 19 6.24156 18.5805 4.81461 17.7829L4.51239 17.6138C4.00782 17.3317 3.57659 16.9395 3.25226 16.4677C2.92792 15.996 2.71922 15.4574 2.64239 14.8938L1.03778 3.11946Z" stroke="#E53935" stroke-width="1.5" />
                                                                    </svg>
                                                                </span>
                                                                Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                
                                            ))
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default TherapistServices;